import { useParams } from 'react-router-dom'

import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import { useLocaleUrlOptions } from 'hooks/useLocaleUrlOptions'
import { buildUrl } from 'lib/url/searchUrlUtils'
import { getTripURL } from 'tripPlanner/utils'

function TripTabRedirect() {
  const { regionCode = '', tripId = '' } = useParams<'regionCode' | 'tripId'>()
  const { locale, languageOptions } = useLocaleUrlOptions()

  return <RedirectWithStatus
    code={301}
    to={buildUrl(getTripURL(tripId), regionCode, undefined, undefined, { locale, languageOptions })}
  />
}

export default TripTabRedirect
